import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getMpfPermissoes } from 'volto-ministerio-publico-federal/actions';

/**
 * Carrega `@mpf-permissoes` a cada login (troca de token). Registrado em
 * `config.settings.appExtras`, então roda em todas as rotas e não renderiza
 * nada. No logout o reducer zera sozinho.
 */
const MpfPermissoesLoader = () => {
  const dispatch = useDispatch();
  const token = useSelector((state: any) => state.userSession?.token);

  useEffect(() => {
    if (token) {
      dispatch(getMpfPermissoes());
    }
  }, [dispatch, token]);

  return null;
};

export default MpfPermissoesLoader;
